import request from '@/service/request';

export const GetProductDetail = (productType: string, productId: any) => {
  return request(
    `/v1/shaft/public/class/ips/vn/${productType}/products/${productId}`,
  );
};

export const GetPlanCmsDetail = (
  productType: string,
  productId: any,
  planId: string,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productId}/plans/cms/${planId}`,
  );
};

export const CreateQuote = (
  productType: string,
  productKey: string,
  planKey: string,
  data: any,
) => {
  return request(
    `/v1/shaft/admin/class/ips/vn/${productType}/products/${productKey}/plans/${planKey}/quotation`,
    {
      method: 'post',
      data: {
        fast_quote: data,
      },
    },
  );
};
